import { memo } from "react";
import { Flex, Span } from "@ir/ui";
import { formatConfidence } from "@/presentation/deduction/components/DeductionDrawer/DeductionInformation/promoMatch/promoMatch.utils";
import { getConfidenceBarColor } from "../utils/promotionDisplay.utils";

interface MatchConfidenceBarProps {
  confidenceScore: number;
  isRefreshing?: boolean;
}

const MatchConfidenceBar = memo(({ confidenceScore, isRefreshing = false }: MatchConfidenceBarProps) => {
  if (isRefreshing) {
    return null;
  }

  const percentage = formatConfidence(confidenceScore);
  const color = getConfidenceBarColor(percentage);

  return (
    <Flex align="center" gap={0.5} wrap="no-wrap" className="match-confidence-bar">
      <Span className={`match-confidence-bar__track match-confidence-bar__track--${color}`}>
        <Span
          className={`match-confidence-bar__fill match-confidence-bar__fill--${color}`}
          style={{ width: `${Math.min(Math.max(percentage, 0), 100)}%` }}
        />
      </Span>
      <Span className="text-grey-700 text-xs font-medium">{percentage}%</Span>
    </Flex>
  );
});

MatchConfidenceBar.displayName = "MatchConfidenceBar";

export { MatchConfidenceBar };
